@if (form) {
  <div class="row">
    <div class="col-12">
      <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
        <span class="required">*</span>
      }</p>
      <input type="text" [readonly]="form.view" [value]="form.answer_value || ''" pInputText
        [attr.inputmode]="form.validation_type === 'number' ? 'decimal' : null"
        (input)="updateValue(form,val)" #val placeholder="กรอกข้อความ">
      @if (errorMsg) {
        <small class="p-error">{{errorMsg}}</small>
      }
      <!-- <app-validate-items [action]="form.question_required" [valid]="form.answer_value"
      (validUpdate)="updateValiDate($event)">
      <input type="text" [readonly]="form.view" [value]="form.answer_value || ''" pInputText
        (input)="updateValue(form,val)" #val placeholder="Type a subheader">
    </app-validate-items> -->
  </div>
</div>
}